import APP_CONST from 'const/app-const';

function guard() {

    let userSession:any = localStorage.getItem(APP_CONST.KEY_STORE_USER);
    if (userSession === null || userSession === undefined || userSession === 'undefined') return false;

    userSession = JSON.parse(userSession as 'string');
    if (!userSession || !userSession.token) return false;

    const currentTime = Math.floor(new Date().getTime() / 1000);
    if (userSession.exp && userSession.exp < currentTime) {

        alert('User Expired');
        return false;
    }

    // if (!userSession.centers.includes('center-sale')) {
    //     alert('Access Denied');
    //     return false;
    // }

    return true;
}
export default guard;